import React from "react";
import {useTranslation} from "react-i18next";

type Proc = {
    pushId : CardReceptionIssuePush;
    pushAddr : CardReceptionIssuePush;
}

const CardReuploadHTML : React.FC<Proc> = ({pushId , pushAddr}) => {
    const { t } = useTranslation();
    return (
        <div className="txtReload">
            <div className="mainTitle">{t("STAT03.reupload.title")}</div>
            {pushId !== undefined
                && pushId != null
                && (
                    <div>
                        <div className="mainTxt">{pushId.messageContent.replace('{0}', '')}</div>
                        <div className="subTxtRed">{pushId.messageDetail}</div>
                    </div>
                )
            }

            {pushAddr !== undefined
                && pushAddr != null
                && (
                    <div>
                        <div className="mainTxt">{pushAddr.messageContent}</div>
                        <div className="subTxtRed">{pushAddr.messageDetail}</div>
                    </div>
                )
            }
        </div>
);
}

export default CardReuploadHTML;